import { ADD_STANDINGS } from "../constants/standingsConstants";

export const addStandings = standings => ({
  type: ADD_STANDINGS,
  payload: standings
});
